var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon pin",
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8v8H0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.379 7.82c.8-1.006 2.637-3.443 2.637-4.812a3.008 3.008 0 1 0-6.016 0C0 4.377 1.833 6.815 2.637 7.82a.473.473 0 0 0 .743 0zm-.371-3.81a1 1 0 1 1 1-1 1 1 0 0 1-1 1z",
    fill: "currentColor",
    transform: "translate(1)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIcon);
export default __webpack_public_path__ + "static/media/pin-icon.3f6cfe84d0a442ba5e04009f0574844e.svg";
export { ForwardRef as ReactComponent };